// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout {
  --sidebar-width: 304px;
  --sidebar-collapsed-width: 76px;
  display: flex;
  height: var(--dataspace-scaled-vh, 100vh);
  min-height: 0;
  overflow: hidden;
  background: var(--bg);
}

.sidebar {
  width: var(--sidebar-width);
  background: var(--card);
  border-right: 1px solid var(--border);
  padding: 16px 12px;
  position: fixed;
  inset: 0 auto 0 0;
  display: flex;
  flex-direction: column;
  height: var(--dataspace-scaled-vh, 100vh);
  overflow: hidden;
  transition: width 0.2s ease, padding 0.2s ease;
  z-index: 1000;
}

.layout > .main {
  margin-left: var(--sidebar-width);
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-width: 0;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  transition: margin-left 0.2s ease;
}

.layout > .main > .container {
  display: flex;
  width: 100%;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  overflow: hidden;
}

.layout > .main > .container > .route-content {
  width: 100%;
  min-height: 0;
  flex: 1 1 auto;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: auto;
}

.layout.layout--data-manager,
.layout.layout--city-tours,
.layout.layout--catalog,
.layout.layout--health-questionnaire {
  height: var(--dataspace-scaled-vh, 100vh);
  min-height: 0;
  overflow: hidden;
}

.layout--data-manager > .main,
.layout--city-tours > .main,
.layout--catalog > .main,
.layout--health-questionnaire > .main {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.layout--data-manager > .main > .container,
.layout--city-tours > .main > .container,
.layout--catalog > .main > .container,
.layout--health-questionnaire > .main > .container {
  min-height: 0;
  overflow: hidden;
}

.layout--data-manager > .main > .container > .route-content,
.layout--city-tours > .main > .container > .route-content,
.layout--catalog > .main > .container > .route-content,
.layout--health-questionnaire > .main > .container > .route-content {
  overflow: hidden;
}

.layout--sidebar-collapsed > .main {
  margin-left: var(--sidebar-collapsed-width);
}

.sidebar.is-collapsed {
  width: var(--sidebar-collapsed-width);
  padding: 16px 10px;
}

.sb-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  position: relative;
  min-height: 55px;
}

.sb-logo {
  background: none;
  border: none;
  padding: 0.5rem;
}

.sb-logo img {
  display: block;
  width: 95px;
  height: auto;
}

.sb-collapse {
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 32px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: #ffffff;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
}

.sb-collapse:hover {
  background: var(--primary-ghost);
  color: var(--primary);
}

.sb-nav {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 4px;
  overscroll-behavior: contain;
  scrollbar-gutter: auto;
}

.sb-section {
  flex-shrink: 0;
  overflow-wrap: anywhere;
  font-size: 12px;
  color: var(--muted);
  text-transform: uppercase;
  letter-spacing: .06em;
  margin: 16px 8px 6px;
}

.sb-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  color: var(--text);
  text-decoration: none;
  font-weight: 500;
  min-height: 40px;
  min-width: 0;
  flex-shrink: 0;
  white-space: normal;
}

.sb-link > span:not(.sb-icon) {
  min-width: 0;
  overflow-wrap: anywhere;
}

.sb-link > .svg-inline--fa,
.sb-link > .sb-icon {
  flex: 0 0 22px;
  width: 22px;
}

.sb-icon {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
}

.sb-badge {
  position: absolute;
  top: -6px;
  right: -8px;
  background: #ef4444;
  color: #fff;
  border-radius: 999px;
  min-width: 18px;
  height: 18px;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  box-shadow: 0 6px 12px rgba(239, 68, 68, 0.25);
}

.sb-link:hover {
  background: var(--primary-ghost);
  text-decoration: none;
}

.sb-link.active {
  background: var(--primary-ghost);
  color: var(--primary);
}

.sb-bottom {
  margin-top: auto;
  padding: 16px 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.icon-pill {
  display: inline-flex;
  align-items: center;
  gap: .45rem;
  padding: .5rem .8rem;
  border: none;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.15);
}

.icon-pill.danger {
  background: var(--danger);
}

.sidebar.is-collapsed .sb-logo {
  width: 44px;
  height: 44px;
  padding: 0.25rem 0;
  margin-top: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar.is-collapsed .sb-logo img {
  width: 100% !important;
  height: 100% !important;
  max-width: 100% !important;
  max-height: 100% !important;
  object-fit: contain;
}

.sidebar.is-collapsed .sb-brand {
  align-items: flex-start;
  min-height: 104px;
}

.sidebar.is-collapsed .sb-collapse {
  left: 50%;
  right: auto;
  transform: translateX(-50%);
}

.sidebar.is-collapsed .sb-nav {
  align-items: stretch;
  padding-right: 0;
}

.sidebar.is-collapsed .sb-section {
  height: 1px;
  margin: 14px 8px 8px;
  padding: 0;
  color: transparent;
  background: var(--border);
  overflow: hidden;
}

.sidebar.is-collapsed .sb-link {
  justify-content: center;
  gap: 0;
  padding: 10px;
}

.sidebar.is-collapsed .sb-link > span:not(.sb-icon),
.sidebar.is-collapsed .icon-pill span {
  display: none;
}

.sidebar.is-collapsed .sb-icon {
  width: auto;
}

.sidebar.is-collapsed .sb-badge {
  top: -10px;
  right: -12px;
}

.sidebar.is-collapsed .sb-bottom {
  padding: 16px 0 8px;
  align-items: center;
}

.sidebar.is-collapsed .icon-pill {
  width: 44px;
  height: 40px;
  justify-content: center;
  padding: 0;
}


/* Readable controls at the browser's natural scale. */
.sb-mobile-toggle { display: none; }
.sb-link, .sb-collapse, .sidebar .icon-pill { min-height: 44px; }
.sb-collapse { width: 44px; }
.sidebar button:focus-visible, .sidebar a:focus-visible { outline: 3px solid #1759ad; outline-offset: 2px; }
.sidebar .sb-link:focus-visible { outline-offset: -3px; }
@media (max-width: 700px) {
  .layout > .main, .layout--sidebar-collapsed > .main { margin-left: 0; padding-top: 60px; }
  .sidebar, .sidebar.is-collapsed { width: 100%; height: 60px; padding: 8px 12px; flex-direction: row; align-items: center; gap: 12px; border-right: 0; border-bottom: 1px solid var(--border); }
  .sidebar .sb-brand, .sidebar.is-collapsed .sb-brand { min-height: 0; margin: 0; }
  .sidebar .sb-logo, .sidebar.is-collapsed .sb-logo { width: 44px; height: 40px; margin: 0; padding: 0; }
  .sidebar .sb-logo img { width: 44px; max-height: 40px; object-fit: contain; }
  .sidebar .sb-collapse { display: none; }
  .sidebar .sb-mobile-toggle { display: block; min-height: 44px; margin-left: auto; padding: 8px 12px; color: var(--text); border: 1px solid var(--border); border-radius: 8px; background: #fff; }
  .sidebar .sb-nav, .sidebar .sb-bottom { display: none; }
  .sidebar.is-mobile-open { height: var(--dataspace-scaled-vh, 100dvh); flex-wrap: wrap; align-content: flex-start; }
  .sidebar.is-mobile-open .sb-nav { display: flex; flex: 0 0 100%; height: calc(100% - 120px); margin-top: 0; }
  .sidebar.is-mobile-open .sb-bottom { display: flex; margin: 0; padding: 0; }
  .sidebar.is-collapsed.is-mobile-open .sb-link { justify-content: flex-start; gap: 12px; }
  .sidebar.is-collapsed.is-mobile-open .sb-link > span:not(.sb-icon), .sidebar.is-collapsed.is-mobile-open .icon-pill span { display: inline; }
  .sidebar.is-collapsed.is-mobile-open .sb-section { height: auto; color: var(--muted); background: none; }
  .sidebar.is-collapsed.is-mobile-open .icon-pill { width: auto; padding: 8px 12px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;;;EAIE,yCAAyC;EACzC,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;EAIE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,SAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,MAAM;EACN,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,UAAU;AACZ;;;AAGA,sDAAsD;AACtD,oBAAoB,aAAa,EAAE;AACnC,8CAA8C,gBAAgB,EAAE;AAChE,eAAe,WAAW,EAAE;AAC5B,0DAA0D,0BAA0B,EAAE,mBAAmB,EAAE;AAC3G,kCAAkC,oBAAoB,EAAE;AACxD;EACE,sDAAsD,cAAc,EAAE,iBAAiB,EAAE;EACzF,kCAAkC,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,sCAAsC,EAAE;EAC9L,sDAAsD,aAAa,EAAE,SAAS,EAAE;EAChF,oDAAoD,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE;EACtG,wBAAwB,WAAW,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;EAC5E,wBAAwB,aAAa,EAAE;EACvC,6BAA6B,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;EAChM,wCAAwC,aAAa,EAAE;EACvD,0BAA0B,0CAA0C,EAAE,eAAe,EAAE,yBAAyB,EAAE;EAClH,kCAAkC,aAAa,EAAE,cAAc,EAAE,0BAA0B,EAAE,aAAa,EAAE;EAC5G,qCAAqC,aAAa,EAAE,SAAS,EAAE,UAAU,EAAE;EAC3E,gDAAgD,2BAA2B,EAAE,SAAS,EAAE;EACxF,2HAA2H,eAAe,EAAE;EAC5I,mDAAmD,YAAY,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;EACxG,kDAAkD,WAAW,EAAE,iBAAiB,EAAE;AACpF","sourcesContent":[".layout {\n  --sidebar-width: 304px;\n  --sidebar-collapsed-width: 76px;\n  display: flex;\n  height: var(--dataspace-scaled-vh, 100vh);\n  min-height: 0;\n  overflow: hidden;\n  background: var(--bg);\n}\n\n.sidebar {\n  width: var(--sidebar-width);\n  background: var(--card);\n  border-right: 1px solid var(--border);\n  padding: 16px 12px;\n  position: fixed;\n  inset: 0 auto 0 0;\n  display: flex;\n  flex-direction: column;\n  height: var(--dataspace-scaled-vh, 100vh);\n  overflow: hidden;\n  transition: width 0.2s ease, padding 0.2s ease;\n  z-index: 1000;\n}\n\n.layout > .main {\n  margin-left: var(--sidebar-width);\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-width: 0;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n  transition: margin-left 0.2s ease;\n}\n\n.layout > .main > .container {\n  display: flex;\n  width: 100%;\n  min-height: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.layout > .main > .container > .route-content {\n  width: 100%;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: auto;\n}\n\n.layout.layout--data-manager,\n.layout.layout--city-tours,\n.layout.layout--catalog,\n.layout.layout--health-questionnaire {\n  height: var(--dataspace-scaled-vh, 100vh);\n  min-height: 0;\n  overflow: hidden;\n}\n\n.layout--data-manager > .main,\n.layout--city-tours > .main,\n.layout--catalog > .main,\n.layout--health-questionnaire > .main {\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.layout--data-manager > .main > .container,\n.layout--city-tours > .main > .container,\n.layout--catalog > .main > .container,\n.layout--health-questionnaire > .main > .container {\n  min-height: 0;\n  overflow: hidden;\n}\n\n.layout--data-manager > .main > .container > .route-content,\n.layout--city-tours > .main > .container > .route-content,\n.layout--catalog > .main > .container > .route-content,\n.layout--health-questionnaire > .main > .container > .route-content {\n  overflow: hidden;\n}\n\n.layout--sidebar-collapsed > .main {\n  margin-left: var(--sidebar-collapsed-width);\n}\n\n.sidebar.is-collapsed {\n  width: var(--sidebar-collapsed-width);\n  padding: 16px 10px;\n}\n\n.sb-brand {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n  position: relative;\n  min-height: 55px;\n}\n\n.sb-logo {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n}\n\n.sb-logo img {\n  display: block;\n  width: 95px;\n  height: auto;\n}\n\n.sb-collapse {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  background: #ffffff;\n  color: #475569;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);\n}\n\n.sb-collapse:hover {\n  background: var(--primary-ghost);\n  color: var(--primary);\n}\n\n.sb-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 8px;\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding-right: 4px;\n  overscroll-behavior: contain;\n  scrollbar-gutter: auto;\n}\n\n.sb-section {\n  flex-shrink: 0;\n  overflow-wrap: anywhere;\n  font-size: 12px;\n  color: var(--muted);\n  text-transform: uppercase;\n  letter-spacing: .06em;\n  margin: 16px 8px 6px;\n}\n\n.sb-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  color: var(--text);\n  text-decoration: none;\n  font-weight: 500;\n  min-height: 40px;\n  min-width: 0;\n  flex-shrink: 0;\n  white-space: normal;\n}\n\n.sb-link > span:not(.sb-icon) {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.sb-link > .svg-inline--fa,\n.sb-link > .sb-icon {\n  flex: 0 0 22px;\n  width: 22px;\n}\n\n.sb-icon {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n}\n\n.sb-badge {\n  position: absolute;\n  top: -6px;\n  right: -8px;\n  background: #ef4444;\n  color: #fff;\n  border-radius: 999px;\n  min-width: 18px;\n  height: 18px;\n  font-size: 11px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n  box-shadow: 0 6px 12px rgba(239, 68, 68, 0.25);\n}\n\n.sb-link:hover {\n  background: var(--primary-ghost);\n  text-decoration: none;\n}\n\n.sb-link.active {\n  background: var(--primary-ghost);\n  color: var(--primary);\n}\n\n.sb-bottom {\n  margin-top: auto;\n  padding: 16px 12px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.icon-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: .45rem;\n  padding: .5rem .8rem;\n  border: none;\n  border-radius: 12px;\n  color: #fff;\n  cursor: pointer;\n  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.15);\n}\n\n.icon-pill.danger {\n  background: var(--danger);\n}\n\n.sidebar.is-collapsed .sb-logo {\n  width: 44px;\n  height: 44px;\n  padding: 0.25rem 0;\n  margin-top: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar.is-collapsed .sb-logo img {\n  width: 100% !important;\n  height: 100% !important;\n  max-width: 100% !important;\n  max-height: 100% !important;\n  object-fit: contain;\n}\n\n.sidebar.is-collapsed .sb-brand {\n  align-items: flex-start;\n  min-height: 104px;\n}\n\n.sidebar.is-collapsed .sb-collapse {\n  left: 50%;\n  right: auto;\n  transform: translateX(-50%);\n}\n\n.sidebar.is-collapsed .sb-nav {\n  align-items: stretch;\n  padding-right: 0;\n}\n\n.sidebar.is-collapsed .sb-section {\n  height: 1px;\n  margin: 14px 8px 8px;\n  padding: 0;\n  color: transparent;\n  background: var(--border);\n  overflow: hidden;\n}\n\n.sidebar.is-collapsed .sb-link {\n  justify-content: center;\n  gap: 0;\n  padding: 10px;\n}\n\n.sidebar.is-collapsed .sb-link > span:not(.sb-icon),\n.sidebar.is-collapsed .icon-pill span {\n  display: none;\n}\n\n.sidebar.is-collapsed .sb-icon {\n  width: auto;\n}\n\n.sidebar.is-collapsed .sb-badge {\n  top: -10px;\n  right: -12px;\n}\n\n.sidebar.is-collapsed .sb-bottom {\n  padding: 16px 0 8px;\n  align-items: center;\n}\n\n.sidebar.is-collapsed .icon-pill {\n  width: 44px;\n  height: 40px;\n  justify-content: center;\n  padding: 0;\n}\n\n\n/* Readable controls at the browser's natural scale. */\n.sb-mobile-toggle { display: none; }\n.sb-link, .sb-collapse, .sidebar .icon-pill { min-height: 44px; }\n.sb-collapse { width: 44px; }\n.sidebar button:focus-visible, .sidebar a:focus-visible { outline: 3px solid #1759ad; outline-offset: 2px; }\n.sidebar .sb-link:focus-visible { outline-offset: -3px; }\n@media (max-width: 700px) {\n  .layout > .main, .layout--sidebar-collapsed > .main { margin-left: 0; padding-top: 60px; }\n  .sidebar, .sidebar.is-collapsed { width: 100%; height: 60px; padding: 8px 12px; flex-direction: row; align-items: center; gap: 12px; border-right: 0; border-bottom: 1px solid var(--border); }\n  .sidebar .sb-brand, .sidebar.is-collapsed .sb-brand { min-height: 0; margin: 0; }\n  .sidebar .sb-logo, .sidebar.is-collapsed .sb-logo { width: 44px; height: 40px; margin: 0; padding: 0; }\n  .sidebar .sb-logo img { width: 44px; max-height: 40px; object-fit: contain; }\n  .sidebar .sb-collapse { display: none; }\n  .sidebar .sb-mobile-toggle { display: block; min-height: 44px; margin-left: auto; padding: 8px 12px; color: var(--text); border: 1px solid var(--border); border-radius: 8px; background: #fff; }\n  .sidebar .sb-nav, .sidebar .sb-bottom { display: none; }\n  .sidebar.is-mobile-open { height: var(--dataspace-scaled-vh, 100dvh); flex-wrap: wrap; align-content: flex-start; }\n  .sidebar.is-mobile-open .sb-nav { display: flex; flex: 0 0 100%; height: calc(100% - 120px); margin-top: 0; }\n  .sidebar.is-mobile-open .sb-bottom { display: flex; margin: 0; padding: 0; }\n  .sidebar.is-collapsed.is-mobile-open .sb-link { justify-content: flex-start; gap: 12px; }\n  .sidebar.is-collapsed.is-mobile-open .sb-link > span:not(.sb-icon), .sidebar.is-collapsed.is-mobile-open .icon-pill span { display: inline; }\n  .sidebar.is-collapsed.is-mobile-open .sb-section { height: auto; color: var(--muted); background: none; }\n  .sidebar.is-collapsed.is-mobile-open .icon-pill { width: auto; padding: 8px 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
